export default __webpack_public_path__ + "static/media/header_espace-prive.b86266eb.svg";